import AdminGroup from "./Group";
export default AdminGroup;
